import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPostsByUserId,
  getUserProfile,
  followUser,
  unfollowUser,
  refreshUserProfile,
} from "../../actions/profileActions";
import Post from "../Posts/Post";
import LoadingPosts from "../Posts/LoadingPosts";
import { Grid, Typography, Button, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paperStyle: {
    width: "100%",
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
    borderRadius: "12px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    "&:hover": {
      boxShadow: theme.shadows[5],
    },
  },

  textTitle: {
    fontWeight: 500,
    fontFamily: "Montserrat, sans-serif",
    color: theme.palette.text.primary,
    fontSize: "1.5rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
    },
  },

  followButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: "0.5rem 2rem",
    borderRadius: "0.25rem",
    boxShadow: theme.shadows[2],
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  unfollowButton: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    padding: "0.5rem 2rem",
    borderRadius: "0.25rem",
    boxShadow: theme.shadows[2],
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));

const Profile = ({
  match: {
    params: { userId },
  },
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { loading: loadingPosts, list } = useSelector((state) => state.post);

  const { user: profile, loading: loadingProfile } = useSelector(
    (state) => state.profile
  );

  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getPostsByUserId(userId));
    dispatch(getUserProfile(userId));
  }, [userId, dispatch]);

  useEffect(() => {
    if (isAuthenticated && user && user.following) {
      dispatch(refreshUserProfile(userId));
    }
  }, [user, isAuthenticated, userId, dispatch]);

  const handleFollow = () => dispatch(followUser(userId));
  const handleUnfollow = () => dispatch(unfollowUser(userId));

  const FollowButton = () => {
    if (!isAuthenticated || !user || !user.following) return null;

    if (user.following.includes(userId)) {
      return (
        <Button variant="outlined" onClick={handleUnfollow}>
          Unfollow
        </Button>
      );
    }

    return (
      <Button variant="contained" color="primary" onClick={handleFollow}>
        Follow
      </Button>
    );
  };

  const ProfileInfo = () => {
    if (!profile || !list) return null;

    const labels = ["Posts", "Followers", "Following"];
    const properties = ["posts", "followers", "following"];

    const profileBox = () => {
      return (
        <Grid container spacing={2} justifyContent="center">
          {labels.map((label, index) => {
            const property = properties[index];
            const count = profile[property]?.length || 0;

            return (
              <Grid item key={label}>
                <Typography className="text-lg font-Montserrat">
                  {label}: {count}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      );
    };

    return (
      <Paper elevation={4}>
        <Grid container justifyContent="center" className="p-4">
          <Typography variant="h2" className="capitalize font-normal">
            {profile.login}
          </Typography>
        </Grid>

        {profileBox()}

        <Grid container justifyContent="center" className="p-4">
          <FollowButton />
        </Grid>
      </Paper>
    );
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={10} md={8}>
        {loadingProfile ? <div>Loading</div> : <ProfileInfo />}

        {loadingPosts ? (
          <LoadingPosts />
        ) : (
          list.map((post) => (
            <Grid className="my-4">
              <Post key={post._id} post={post} />
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  );
};

export default Profile;
